module.exports = __webpack_public_path__ + "img/mypage-active.7eee6691.png";